import React from 'react'

export default function EducationItem(props) {
    const {degree,institution,duration,img}=props.data;
  return (
    <>
        <div className="timeline-box">
                	<div className="timeline-title">
                    	<div className="timeline-img">
                            <img src={img} />
                        </div>
                        <div className="timeline-details">
                            <h3>
                                {degree}
                            </h3>
                            <h4>
                                {institution}
                            </h4>
                            <p>
                                {duration}
                            </p>
                        </div>
                    </div>
                </div>
    </>
  )
}
